export default [
  {
    name: 'email',
    type: 'text',
    value: '',
    validation: 'email|required',
    tableDisplay: true,
    allowEdit: false,
    icon: 'email',
  },
  {
    name: 'role',
    type: 'select',
    value: '',
    validation: 'required',
    options: ['admin', 'editor', 'viewer'],
    tableDisplay: true,
    allowEdit: true,
    icon: 'pan_tool',
  },
  {
    name: 'description',
    type: 'text',
    value: '',
    validation: '',
    tableDisplay: true,
    allowEdit: true,
    icon: 'message',
  },
  {
    name: 'customName',
    type: 'text',
    value: '',
    validation: '',
    tableDisplay: true,
    allowEdit: true,
    icon: 'person',
  },
]
